import { Grid, Box } from "@mui/material";
import React from "react";
import logo from "../../images/logo.svg";
import logoIcon from "../../images/logo-icon.svg";
import theme from "../../utils/theme";

const LeftGrid = () => {
  return (
    <Grid
      item
      xs={6}
      sx={{ backgroundColor: theme.palette.brand.light, height: "100vh" }}
    >
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minWidth="100%"
        minHeight="100vh"
      >
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          sx={{
            height: "100vh",
            width: "100%",
            borderTopRightRadius: "200px",
            background: theme.palette.brand.dark,
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* Logo at top center */}
          <Box
            display="flex"
            justifyContent="center"
            sx={{ pt: "178px" }}
          >
            <img style={{ width: "294px" }} src={logo} alt="Surgo Health Logo" />
          </Box>

          {/* Logo icon at bottom left */}
          <Box
            sx={{
              position: "absolute",
              bottom: "-5%",
              left: "0",
            }}
          >
            <img src={logoIcon} alt="logo icon" />
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};

export default LeftGrid;
